import * as React from "react";
const SvgFiRrBatterySlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-battery-slash_svg__a)">
      <path
        fill="#062147"
        d="M21.784 16H23a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-1.101a5.01 5.01 0 0 0-4.9-4H5.415L1.707.293A1 1 0 1 0 .292 1.707l22 22a.997.997 0 0 0 1.415 0 1 1 0 0 0 0-1.414l-3.582-3.582A5.95 5.95 0 0 0 21.784 16M7.414 6H17c1.654 0 3 1.346 3 3v5.5c0 1.034-.512 2.111-1.291 2.796zM14 19a1 1 0 0 1-1 1H5c-2.757 0-5-2.243-5-5V9c0-.879.23-1.744.669-2.5A.999.999 0 1 1 2.4 7.501a3 3 0 0 0-.401 1.5v6c0 1.654 1.346 3 3 3h8c.554 0 1 .447 1 .999"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-battery-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBatterySlash;
